import React from 'react';

const LeaseDetails = ({ selectedLease, handleCloseModal }) => {
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return 'N/A';
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(amount);
  };


  return (
    <>
      <div
        className="modal fade show d-block"
        style={{ zIndex: '9999' }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">

            {/* HEADER */}
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">
                {selectedLease?.lease_name} – Lease Details
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={handleCloseModal}
              />
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div className="row">

                {/* BASIC INFO */}
                <div className="col-md-6 mb-4">
                  <div className="card">
                    <div className="card-header bg-light">
                      <h6 className="mb-0">Basic Information</h6>
                    </div>
                    <div className="card-body">
                      <table className="table table-sm">
                        <tbody>
                          <tr>
                            <td className="fw-bold">Lease Name:</td>
                            <td>{selectedLease?.lease_name || '-'}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Lease Type:</td>
                            <td>{selectedLease?.lease_type || '-'}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Status:</td>
                            <td>
                              <span className="badge bg-secondary">
                                {selectedLease?.status || '-'}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Invite Status:</td>
                            <td>{selectedLease?.invite_status || '-'}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Start Date:</td>
                            <td>{selectedLease?.start_date?.split('T')[0]}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">End Date:</td>
                            <td>{selectedLease?.end_date?.split('T')[0]}</td>
                          </tr>
                             
                          <tr>
                            <td className="fw-bold">Landlord Have Signed:</td>
                            <td>{selectedLease?.landlord_signed ? 'Yes' : 'No'}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Tenant Have Signed:</td>
                            <td>{selectedLease?.tenant_signed ? 'Yes' : 'No'}</td>
                          </tr>
                            <tr>
                            <td className="fw-bold">Additional smoking rules:</td>
                            <td>{selectedLease?.additional_smoking_rules ? 'Yes' : 'No'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* RENT DETAILS */}
                <div className="col-md-6 mb-4">
                  <div className="card">
                    <div className="card-header bg-light">
                      <h6 className="mb-0">Rent & Payments</h6>
                    </div>
                    <div className="card-body">
                      <table className="table table-sm">
                        <tbody>
                          <tr>
                            <td className="fw-bold">Base Rent:</td>
                            <td>{formatCurrency(selectedLease?.base_rent_for_unit)}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Payment Day:</td>
                            <td>{selectedLease?.monthly_payment_day}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Security Deposit:</td>
                            <td>{formatCurrency(selectedLease?.rent_deposit_amount)}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Key Deposit:</td>
                            <td>{formatCurrency(selectedLease?.key_deposit_amount)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                   <div className="card mt-2">
                    <div className="card-header bg-light">
                      <h6 className="mb-0">Responsibility</h6>
                    </div>
                    <div className="card-body ">
                      <table className="table table-sm">
                        <tbody>
                          <tr>
                            <td> <b>Electricity: </b>{selectedLease?.electricity || '-'}, {" "}  <b>Water: </b>{selectedLease?.water || '-' }, {" "} <b>Heat: </b>{selectedLease?.heat || '-' }</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                          {selectedLease.pdf_path && <a className="btn btn-sm btn-outline-primary mt-2" href={selectedLease.pdf_path} target="_blank" rel="noreferrer">Lease Agreement PDF</a>}

                </div>

                {/* PEOPLE */}
                <div className="col-md-6 mb-4">
                  <div className="card">
                    <div className="card-header bg-light">
                      <h6 className="mb-0">People</h6>
                    </div>
                    <div className="card-body">
                      <table className="table table-sm">
                        <tbody>
                          <tr>
                            <td className="fw-bold">Landlord:</td>
                            <td>
                              {selectedLease?.landlord
                                ? `${selectedLease.landlord.first_name} ${selectedLease.landlord.last_name}`
                                : '-'} {' '}
                                ({selectedLease?.landlord?.email || '-'})
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Tenant:</td>
                            <td>
                              {selectedLease?.tenant
                                ? `${selectedLease.tenant.first_name} ${selectedLease.tenant.last_name}`
                                : '-'} {' '}
                                ({selectedLease?.tenant?.email || '-'})
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Receive notices by email:</td>
                            <td>{selectedLease?.recieved_notice_by_mail ? 'Yes' : 'No'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* PROPERTY */}
                <div className="col-md-6 mb-4">
                  <div className="card">
                    <div className="card-header bg-light">
                      <h6 className="mb-0">Property</h6>
                    </div>
                    <div className="card-body">
                      <table className="table table-sm">
                        <tbody>
                          <tr>
                            <td className="fw-bold">Property Name:</td>
                            <td>{selectedLease?.property?.property_name}</td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Address:</td>
                            <td>
                              {selectedLease?.property?.street_number},{' '}
                              {selectedLease?.property?.street_name},{' '}
                              {selectedLease?.property?.city},{' '}
                              {selectedLease?.property?.postal_code}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-bold">Province:</td>
                            <td>{selectedLease?.property?.province?.name}</td>
                          </tr>
                           <tr>
                            <td className="fw-bold">Parking Space:</td>
                            <td>{selectedLease?.parking_space}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleCloseModal}>
                Close
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* BACKDROP */}
      {/* <div className="modal-backdrop fade show" onClick={handleCloseModal} /> */}
       {/* BACKDROP */}
      <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </>
  );
};

export default LeaseDetails;
